<template>
	<v-select
		v-model="currentChannel"
		:items="channelItems"
		item-props.color="white"
		label="Select Channel"
		hide-selected
		hide-details
		density="compact"
		variant="outlined"
		clearable
		@update:model-value="updateAssignedChannel"
	/>
</template>

<script>
import _ from "lodash";
import ControllerTypes from "@/enums/ControllerTypes";

export default {
	name: "ChannelDropdown",

	props: ["channelData", "allChannels", "controllerType"],

	emits: ["updateAssignedChannel"],

	data() {
		return {
			currentChannel: null
		};
	},

	computed: {
		studioSettings() {
			return this.$store.getters.getStudioSettings();
		},

		channelItems() {
			let channels = [];
			let numberOfChannels = this.controllerType === ControllerTypes.Default ? 4 : 6;

			for (let channelNumber = 1; channelNumber <= numberOfChannels; channelNumber++) {
				channels.push({
					value: `channel${channelNumber}`,
					title: `Channel ${channelNumber}`
				});
			}

			return channels;
		}
	},

	watch: {
		"channelData.assignment"(value) {
			this.currentChannel = value;
		}
	},

	mounted() {
		if (this.channelData.assignment) {
			this.currentChannel = this.channelItems.find(ch => {
				return ch.value === this.channelData.assignment;
			});
		}
	},

	methods: {
		updateAssignedChannel(ev) {
			let channelIndex = this.allChannels.findIndex(channel => {
				return _.isEqual(channel, this.channelData);
			});

			this.$emit("updateAssignedChannel", {
				channelIndex: channelIndex,
				channelName: ev
			});
		}
	}
};
</script>